import { useMutation, useQuery, useQueryClient } from "react-query"
import * as consultationApi from "./consultationApi"

const invalidateConsultationQueries = (queryClient: ReturnType<typeof useQueryClient>) => {
  queryClient.invalidateQueries(['consultation'])
  queryClient.invalidateQueries(['consultationsByDateRange'])
  queryClient.invalidateQueries(['scheduleEventsByDate'])
  queryClient.invalidateQueries(['scheduleEventsByDateRange'])
  queryClient.invalidateQueries(['dayViewEvents'])
  queryClient.invalidateQueries(['dateRangeViewEvents'])
}

export const useUpdateConsultationMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (consultation: consultationApi.UpdateConsultationRequest) => consultationApi.updateConsultation(consultation),
    onSuccess: () => {
      invalidateConsultationQueries(queryClient)
    }
  })
}

export const useDeleteConsultationMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (calendarEventId: number) => consultationApi.deleteConsultation(calendarEventId),
    onSuccess: () => {
      invalidateConsultationQueries(queryClient)
    }
  })
}

export const useConsultationProjectsQuery = (customerId: number | null) => {
  return useQuery(['consultationProjects', customerId], {
    queryFn: () => consultationApi.getConsultationProjects(customerId!),
    refetchOnWindowFocus: false,
    enabled: customerId !== null && customerId !== 0
  })
}
